export default "__VITE_ASSET__B2VpwTHq__"